import Document from "~/models/read/Document";
import Service from "~/models/read/Service";
import Money from '@/models/Money';
import moment from "moment/moment";

const STATUS = {
  UNPAID: 'unpaid',
  DRAFT: 'draft',
  PROCESSING_PAYMENT: 'processing_payment'
}

export default class BasketOrder {
  private readonly _id: string;
  private readonly _status: string;
  private readonly _term: Number;
  private readonly _draftedAt: Date;
  private readonly _links: object;
  private readonly _document: Document;
  private readonly _services: Array<Service>;
  private readonly _totalPrice: Money|null;
  private readonly _relatedFreemiumPlagiarismCheckOrderId: string|null;
  constructor({
      id,
      status,
      term,
      draftedAt,
      links,
      document,
      services,
      totalPrice,
      freeCheck,
  }) {
    this._id = id;
    this._status = status;
    this._term = Number(term);
    this._draftedAt = new Date(draftedAt);
    this._links = links;
    this._document = new Document(document);
    this._services = services ? services.map(s => new Service(s)) : null;
    this._totalPrice = totalPrice ? new Money({amount: totalPrice.amount / 100, currency: totalPrice.currency}) : null;
    this._relatedFreemiumPlagiarismCheckOrderId = freeCheck ? freeCheck.id : null;
  }

  get id(): string {
    return this._id;
  }

  get status(): string {
    return this._status;
  }

  get isUnpaid(): boolean {
      return this._status === STATUS.UNPAID;
  }

  get isDraft(): boolean {
      return this._status === STATUS.DRAFT;
  }

  get isProcessingPayment(): boolean {
      return this._status === STATUS.PROCESSING_PAYMENT;
  }

  get isPendingPaymentOverdue(): boolean {
    return moment().isAfter(moment(this._draftedAt).add(5, 'minutes').toDate());
  }

  get term(): Number {
    return this._term;
  }

  get draftedAt(): Date {
    return this._draftedAt;
  }

  get document(): Document {
    return this._document;
  }

  get links(): object {
    return this._links;
  }

  get services(): Array<Service> {
    return this._services;
  }

  get hasExpertReview() {
    return this._services.findIndex(service => service.type === 'expert_review') !== -1;
  }

  get totalPrice(): Money|null {
    return this._totalPrice;
  }

  get relatedFreemiumPlagiarismCheckOrderId(): string|null {
    return this._relatedFreemiumPlagiarismCheckOrderId;
  }

  get isUnpaidAndAfterOneMonthAgo(): boolean {
    let oneMonthAgo = moment().subtract(1, 'month');
    return this.isUnpaid && moment(this.draftedAt).isAfter(oneMonthAgo);
  }

  get isDraftAndAfterOneMonthAgo(): boolean {
    let oneMonthAgo = moment().subtract(1, 'month');
    return this.isDraft && moment(this.draftedAt).isAfter(oneMonthAgo);
  }
}
